$(function () {
  if ($('a[href="#nwwiModal"]').length) {
    $('a[href="#nwwiModal"]').attr('data-modal', 'nwwiModal');
  }

  $(document).on('click', '[data-modal], .modal__close', function () {
    var video = $('#modal--videoModal');
    $('.modal').removeClass('active');
    var modal = $(this).attr('data-modal');

    if ($(this).hasClass('modal__close')) {
      $('html, body').css('overflow', '');
      if (video.length) {
        video.find('video').get(0).pause();
      }
    } else {
      $('html, body').css('overflow', 'hidden');
      if (modal == 'videoModal') {
        video.find('video').get(0).play();
      }
    }

    $('.modal__close').css(
      'left',
      $('.header__content__toggle__span').offset().left
    );
    $('#modal--' + modal).addClass('active');
  });

  $(window).on('resize', function () {
    $('.modal__close').css(
      'left',
      $('.header__content__toggle__span').offset().left
    );
  });
});

$(document).keydown(function (event) {
  if (event.keyCode == 27) {
    var video = $('#modal--videoModal');
    $('.modal').removeClass('active');
    $('html, body').css('overflow', '');
    if (video.length) {
      video.find('video').get(0).pause();
    }
  }
});
